import { useToast } from "@mallardbay/lib-react-components"

import type { MutationCreateQuoteArgs } from "~graphql/generated/graphql"
import { useCreateQuoteMutation } from "~graphql/generated/graphql"
import type { UseCreateQuoteArgs } from "~utils/quote-helpers"
import { useCreateQuoteParams } from "~utils/quote-helpers"

export default function useCreateQuote({
    quoteArgs,
    onCompleted,
}: {
    quoteArgs: UseCreateQuoteArgs
    onCompleted: (quoteId: string) => void
}) {
    const { showError } = useToast()

    const createQuoteParams = useCreateQuoteParams(quoteArgs)
    const isValid = isQuoteArgsValid(createQuoteParams)

    const [createQuote, { loading: isLoading, error }] = useCreateQuoteMutation(
        {
            variables: createQuoteParams,
            onError: showError,
            onCompleted: (data) => onCompleted(data.createQuote.id),
        }
    )

    return { createQuote, isLoading, error, isValid }
}

function isQuoteArgsValid({ data }: MutationCreateQuoteArgs) {
    // These args have been formatted for the api. Because of this, there
    // can be a single date (even though we always require two for form state).
    if (data.dates.length < 1) return false
    if (!data.packages?.length) return false

    const hasPricingPackages = data.packages.every((quotePackage) =>
        Boolean(quotePackage.pricing_package_id)
    )
    const hasGuests = data.packages.every((quotePackage) =>
        Boolean(quotePackage.number_of_guests)
    )

    return hasPricingPackages && hasGuests
}
